var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleDriveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google_Drive_Logo",
    clipPath: "url(#clip0_1435_3032)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.13145 27.4252L3.5417 30.1534C3.83475 30.7278 4.25598 31.1791 4.7505 31.5073L9.78712 21.7432H-0.286133C-0.286133 22.3791 -0.139613 23.015 0.153427 23.5893L2.13145 27.4252Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.7029 10.2563L10.6662 0.492188C10.1718 0.820392 9.75049 1.27168 9.45747 1.84603L0.153427 19.8973C-0.134223 20.4593 -0.28575 21.0957 -0.286133 21.7435H9.78712L15.7029 10.2563Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.6555 31.5073C27.15 31.1791 27.5713 30.7278 27.8643 30.1534L28.4504 29.0252L31.2527 23.5893C31.5456 23.015 31.6921 22.3791 31.6921 21.7432H21.6182L23.7618 26.4611L26.6555 31.5073Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.7026 10.2564L20.7393 0.492307C20.2448 0.164103 19.677 0 19.0909 0H12.3144C11.7283 0 11.1605 0.184615 10.666 0.492307L15.7026 10.2564Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.6191 21.7432H9.7876L4.75098 31.5073C5.24549 31.8355 5.81326 31.9996 6.39932 31.9996H25.0074C25.5935 31.9996 26.1612 31.815 26.6557 31.5073L21.6191 21.7432Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M26.6006 10.8717L21.9486 1.84603C21.6555 1.27168 21.2343 0.820392 20.7398 0.492188L15.7031 10.2563L21.6189 21.7435H31.6738C31.6738 21.1076 31.5273 20.4717 31.2344 19.8973L26.6006 10.8717Z",
    fill: "#FFBA00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1435_3032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDriveIcon);
export default __webpack_public_path__ + "static/media/google-drive-icon.b458bba51153dc6fc2f1bfc82350c40c.svg";
export { ForwardRef as ReactComponent };